import { createAction } from 'redux-actions';
import types from './types';

export const setFollowerCounts = createAction(types.SET_FOLLOWER_COUNTS);
export const increaseFollowingsCounter = createAction(types.INCREASE_FOLLOWINGS_COUNTER);
export const increaseFollowersCounter = createAction(types.INCREASE_FOLLOWERS_COUNTER);
export const reduceFollowingsCounter = createAction(types.REDUCE_FOLLOWINGS_COUNTER);
